import axios from "axios";
import qs from "qs";

const baseURL = window._env_.REACT_APP_POI_CMS_URL;

function handleError(error) {
  if (error.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    switch (error.response.status) {
      case 401:
        throw new Error("Unauthorized");
      case 404:
        throw new Error("Not Found");
      default:
        const errorMessage =
          error.response.data?.errors?.[0]?.message ??
          `Got a ${error.response.status} error with no message from the server`;
        throw new Error(errorMessage);
    }
  } else if (error.request) {
    // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
    // http.ClientRequest in node.js
    throw new Error("No response received");
  } else {
    // Something happened in setting up the request that triggered an Error
    throw new Error(error.message);
  }
}

export default class CmsService {
  constructor() {
    this.api = axios.create({
      baseURL,
      paramsSerializer: (params) => qs.stringify(params, { indices: false }),
      headers: {
        "Content-Type": "application/json",
      },
    });
  }

  async get(url, config) {
    try {
      const response = await this.api.get(url, config);
      return response.data;
    } catch (error) {
      handleError(error);
    }
  }
  async getPageSingleType(page) {
    const pages = await this.get(`/api/${page}`);
    return pages.data?.attributes;
  }
  async getPageCollectionTypes(page) {
    const pages = await this.get(`/api/${page}`);
    return pages.data?.[0].attributes;
  }
  async getUnavailibility(page) {
    const pages = await this.get(`/api/${page}`);
    return pages.data?.[0].attributes;
  }
}
